export default {
  brand: 'Sun Power',
  studio: 'Estudio',
  lottery: 'Sorteo',
  companyHome: 'Empresa',
  companyHomeNotConfigured: 'Sitio de la empresa no configurado',
  game: 'Juegos',
  profile: 'Perfil',
  service: 'Soporte',
  serviceNotConfigured: 'Enlace de soporte no configurado',
  language: 'Idioma',
  login: 'Iniciar sesión',
  register: 'Registrarse',
  email: 'Correo',
  password: 'Contraseña',
  inviteCode: 'UID',
  uid: 'UID',
  shareLink: 'Enlace para compartir',
  copyLink: 'Copiar enlace',
  copied: 'Copiado',
  copyFail: 'Error al copiar',
  recharge: 'Recargar',
  withdraw: 'Retirar',
  exchange: 'Canjear',
  balanceUsd: 'Saldo USD',
  balanceKwh: 'Energía kWh',
  checkin: 'Check-in',
  upgrade: 'Nivel',
  team: 'Mi equipo',
  basic: 'Básico',
  vip1: 'VIP1',
  vip2: 'VIP2',
  vip3: 'VIP3',
  activity: 'Actividad',
  unitPrice: 'Precio unitario',
  quantity: 'Cantidad',
  minQtyTip: 'Pedido mínimo: {n}',
  expectKwh: 'Energía esperada',
  totalAmount: 'Monto total',
  progress: 'Progreso',
  buy: 'Comprar',
  buyConfirm: 'Confirmar compra',
  confirmBuy: 'Pagar',
  buyConfirmTip: 'Se descontará de tu saldo USD. No se puede deshacer.',
  buySuccess: 'Compra exitosa',
  productName: 'Producto',
  amount: 'Monto',
  rechargeRate: 'Tipo de cambio',
  rechargeActual: 'Monto a acreditar',
  enterAmount: 'Ingrese el monto',
  network: 'Red',
  selectNetwork: 'Seleccione la red',
  withdrawAddress: 'Dirección',
  enterWithdrawAddress: 'Ingrese la dirección',
  txHash: 'Hash Tx',
  txHashOptional: 'Opcional tras la transferencia',
  copyAddress: 'Copiar dirección',
  rechargeHint: 'Envíe USDT a la dirección; el saldo se acreditará en breve tras enviar',
  withdrawHint: 'El saldo se retiene al enviar; se descuenta comisión y se paga tras aprobación',
  withdrawFeeRate: 'Tasa de comisión',
  withdrawFee: 'Comisión',
  withdrawReceive: 'Recibirá',
  withdrawTooLow: 'Monto demasiado bajo tras comisión',
  rechargeSubmitted: 'Recarga enviada',
  withdrawSubmitted: 'Retiro enviado',
  noQr: 'Sin código QR',
  noRechargeAddress: 'Dirección no configurada',
  rechargeProof: 'Comprobante',
  rechargeProofTip: 'Suba la captura de la transferencia exitosa',
  rechargeProofRequired: 'Suba el comprobante',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  kyc: 'KYC',
  realName: 'Nombre real',
  idCard: 'Documento',
  contact: 'Contacto',
  contactPlaceholder: 'Teléfono / WhatsApp / Telegram',
  contactRequired: 'Contacto obligatorio',
  idFront: 'Frente del documento',
  idBack: 'Reverso del documento',
  kycStatus: 'Estado KYC',
  kycNone: 'Sin verificar',
  kycPending: 'En proceso',
  kycApproved: 'Verificado',
  kycRejected: 'No aprobado',
  kycTip: 'Complete sus datos y suba ambas caras del documento',
  kycRequired: 'Nombre y documento obligatorios',
  kycNeedPhotos: 'Suba las fotos del documento',
  kycSubmitted: 'Enviado, espere por favor',
  submit: 'Enviar',
  logout: 'Salir',
  appDownload: 'Descargar App',
  downloadPickTip: 'Elija el sistema de su teléfono y siga la guía de instalación',
  downloadAndroidShort: 'Paquete APK (Android)',
  downloadIosShort: 'Perfil de configuración (iPhone / iPad)',
  downloadNow: 'Descargar ahora',
  downloadAndroidSteps: [
    'Toque el botón de abajo para descargar el APK',
    'Abra Archivos / Descargas, busque el paquete Sun Power y ábralo',
    'Si Google Play Protect dice que la app está bloqueada: toque «Instalar de todos modos»',
    'Si se bloquean orígenes desconocidos: Ajustes → Apps → Acceso especial → Instalar apps desconocidas, permita el navegador o el administrador de archivos',
    'Siga las instrucciones en pantalla para instalar y luego abra Sun Power'
  ],
  downloadIosSteps: [
    'Toque el botón de abajo; Safari abrirá el perfil de instalación',
    'Si ve «Perfil descargado»: abra Ajustes → Perfil descargado (o General → VPN y gestión de dispositivos)',
    'Toque Instalar, introduzca el código y confirme',
    'Tras instalar, abra Sun Power desde la pantalla de inicio',
    'Si no abre: Ajustes → General → VPN y gestión de dispositivos → seleccione el perfil → Confiar'
  ],
  downloadAndroidNote: 'Esta app se descarga desde nuestro sitio, no desde Google Play. La alerta de Play Protect es normal: elija «Instalar de todos modos».',
  downloadIosNote: 'Use Safari para instalar. Otros navegadores pueden no instalar el perfil correctamente.',
  downloadStarting: 'Preparando descarga…',
  downloadStarted: 'Descarga iniciada. Revise el navegador o las notificaciones',
  downloadIosStarted: 'Abriendo el perfil de instalación. Siga las instrucciones',
  downloadFail: 'Error al descargar. Inténtelo de nuevo',
  downloadUnavailable: 'Paquete no disponible. Contacte con soporte',
  legalLicense: 'Licencia legal',
  businessReward: 'Operación y recompensas',
  companyNews: 'Noticias',
  newsEmpty: 'Sin noticias',
  newsAttachment: 'Ver archivo',
  loading: 'Cargando…',
  attachmentLoadFail: 'No se pudo cargar el archivo. Inténtelo de nuevo.',
  vipLevelNotify: 'Nivel VIP',
  vipLevelChanged: 'Su nivel VIP cambió de {from} a {to}',
  gotIt: 'Entendido',
  loginNotice: 'Aviso',
  roulette: 'Ruleta rusa',
  prizes: 'Premios',
  lotteryRules: 'Reglas del sorteo',
  draw: 'Sortear',
  lotteryTimes: 'Oportunidades',
  lotteryWin: '¡Has ganado!',
  lotteryThanks: 'Gracias por participar',
  lotteryThanksShort: 'Gracias',
  lotteryThanksTip: 'Sin premio esta vez — inténtalo de nuevo',
  lotteryRewardTip: '{reward} se ha acreditado en tu cuenta',
  lotteryTimesReward: 'Obtuviste {n} oportunidad(es)',
  lotteryNoChance: 'Sin oportunidades',
  catchSun: 'Atrapa el sol',
  startGame: 'Empezar',
  score: 'Puntos',
  timeLeft: 'Tiempo',
  gameOver: 'Fin del juego',
  reward: 'Recompensa',
  timesLeft: 'Intentos restantes',
  gameNoChance: 'Sin partidas hoy',
  announcement: 'Anuncio',
  noData: 'Sin datos',
  loginTip: 'Inicia sesión con correo',
  registerTip: 'Se requiere UID',
  emailPlaceholder: 'Tu correo',
  passwordPlaceholder: 'Tu contraseña',
  confirmPassword: 'Confirmar',
  confirmPasswordPlaceholder: 'Repite la contraseña',
  invitePlaceholder: 'Introduzca el UID',
  emailRequired: 'Correo requerido',
  passwordRequired: 'Contraseña requerida',
  passwordMin: 'Mínimo 6 caracteres',
  confirmPasswordRequired: 'Confirma la contraseña',
  passwordMismatch: 'Las contraseñas no coinciden',
  inviteRequired: 'UID requerido',
  noAccount: '¿Sin cuenta?',
  hasAccount: '¿Ya tienes cuenta?',
  registerSuccess: 'Registro completado',
  show: 'Ver',
  hide: 'Ocultar',
  back: 'Volver',
  level: 'Nivel',
  checkinDays: 'Días seguidos',
  checkinTip: '{days} días seguidos = 1 oportunidad de sorteo',
  doCheckin: 'Firmar ahora',
  alreadyCheckin: 'Ya firmaste hoy',
  checkinSuccess: 'Check-in OK',
  checkinLottery: 'Check-in OK, +1 sorteo',
  upgradeTip: 'VIP1 requiere todas las condiciones',
  kycDone: 'KYC listo',
  firstRecharge: 'Primera recarga',
  inviteKyc: 'Invitados KYC',
  inviteRecharge: 'Invitado recargó',
  teamCount: 'Invitados directos',
  teamL1: 'Nivel 1',
  teamL2: 'Nivel 2',
  teamL3: 'Nivel 3',
  teamAll: 'Todos',
  teamInviter: 'Invitado por',
  teamInviterNone: 'Sin superior (registro sin invitación de miembro)',
  teamDownline: 'Mis invitados',
  teamUpL1: 'Superior N1',
  teamUpL2: 'Superior N2',
  teamUpL3: 'Superior N3',
  teamUpRel1: 'Quién le invitó directamente',
  teamUpRel2: 'Quién invitó a su superior',
  teamUpRel3: 'Superior dos niveles arriba',
  teamParentSelf: 'Invitación directa (por usted)',
  teamParentL1: 'Referente N1',
  teamParentL2: 'Referente N2',
  teamRefByL1: 'Invitado por N1 {email}',
  teamRefByL2: 'Invitado por N2 {email}',
  teamRefL1: 'Bajo N1 {email}',
  logs: 'Historial',
  myOrders: 'Mis pedidos',
  dailyRebate: 'Dividendos diarios',
  rebateToday: 'Hoy',
  rebateTotal: 'Total',
  rebateTip: 'La rebaja diaria convierte kWh reservado a saldo USD para retirar. Active la tarea programada para generar registros.',
  totalKwh: 'kWh total',
  pendingKwh: 'Pendiente',
  releasedKwh: 'Liberado',
  orderStatus: {
    '0': 'Activo',
    '1': 'Completado',
    '2': 'Cerrado'
  },
  exchangeTip: 'Convertir kWh reservado a saldo USD',
  exchangeAvailable: 'Disponible',
  exchangeRate: 'Tasa',
  exchangeFee: 'Comisión',
  exchangeAmountKwh: 'Cantidad (kWh)',
  exchangeAll: 'Todo',
  exchangeReceive: 'Recibirá',
  exchangeExceed: 'Supera el kWh disponible',
  exchangeNoKwh: 'Sin kWh para canjear',
  success: 'Éxito',
  playing: 'Jugando',
  tapSun: 'Toca el sol que cae',
  accountType: {
    USD: 'USD',
    KWH: 'kWh'
  },
  logType: {
    RECHARGE: 'Recarga',
    WITHDRAW: 'Retiro',
    WITHDRAW_REFUND: 'Reembolso de retiro',
    EXCHANGE: 'Canje',
    GAME: 'Premio del juego',
    LOTTERY: 'Lotería',
    INVITE_KYC: 'Premio por invitar KYC',
    BUY_PRODUCT: 'Compra de producto',
    REBATE_Ln: 'Comisión L{n}',
    REBATE_L1: 'Comisión L1',
    REBATE_L2: 'Comisión L2',
    REBATE_L3: 'Comisión L3',
    DAILY_REBATE: 'Retorno diario',
    MANAGE_REWARD: 'Premio de gestión',
    ADMIN_ADJUST: 'Ajuste admin'
  }
}
